<template src="./AppHeader.html"></template>
<style lang='scss' scoped src="./AppHeader.scss"></style>
<script>
import {
  SfButton,
  SfHeader,
  SfIcon,
  SfImage,
  SfMegaMenu,
  SfSearchBar,
  SfOverlay,
  SfBadge,
  SfLoader,
    SfLink

} from '@storefront-ui/vue';
import {OrkLoader} from "@/components/Ork";
import SearchResults from '@/components/SearchResults';
import SearchAutocomplete from '@/components/SearchAutocomplete';
import {icons} from "@/utils/icons";
import {clickOutside} from '@storefront-ui/vue/src/utilities/directives/click-outside/click-outside-directive.js';
import Api from "@/api/Api";
import GtagEvent from "@/utils/GtagEvent";

export default {
  name: 'AppHeader',
  components: {
    SfLink,
    OrkLoader,
    SfButton,
    SfHeader,
    SfImage,
    SfIcon,
    SfMegaMenu,
    SfSearchBar,
    SfBadge,
    SfLoader,
    SfOverlay,
    SearchResults,
    SearchAutocomplete,
  },
  data() {
    return {
      icons: icons,
      term: '',
      debounceSearch: null,
      searchValue: '',
      activeMenu: null,
      isShowMenu: false,
      loadingSearch: false,
      accountIcon: 'profile',
      cartTotalItems: 0,
      searchResult: {content: [], totalItems: 0, loading: false},
      searchTerm: '',
      searchTerms: [],
      showAutocomplete: false,
    };
  },
  directives: {clickOutside},
  computed: {
    isSearchOpen: {
      get() {
        return this.$store.getters.isSearchOpen
      }
    },
    categoryTree: {
      get() {
        return this.$store.getters.getCategoryTree
      }
    },
    user: {
      get() {
        return this.$store.getters.getProfile
      }
    },
    isAuthenticated: {
      get() {
        return this.$store.getters.isAuthenticated
      }
    },
    cart: {
      get() {
        return this.$store.getters.getCart
      }
    }
  },


  mounted() {
    this.$store.dispatch('getMe');
    this.$store.dispatch('getCart');
  },
  watch: {
    $route: 'routeSearchTerm'
  },
  methods: {
    routeSearchTerm(){
      this.searchTerm=this.$route.query.searchTerm?this.$route.query.searchTerm:'';
    },
    showMenu(isShow, category) {
      this.activeMenu = category;
      this.isShowMenu = isShow;
    },
    // mutation de isModalLogin
    handleAccountClick() {
      if (this.isAuthenticated) {
        return this.$router.push('/mon-compte');
      } else {
        this.$store.dispatch('toggleLoginModal',{open:true})
      }
    },
    toggleCartSidebar() {
      this.$store.dispatch('toggleCartSidebar')
    },
    removeSearchResults() {
      this.searchTerms = [];
      this.searchResult = {content: [], totalItems: 0, loading: false}
    },
    closeSearch() {
      //  this.searchTerm = '';
      this.searchTerms = [];
      this.searchResult = {content: [], totalItems: 0, loading: false}
      this.$store.dispatch('closeSearch')
    },

    toggleSearch() {
      this.$store.dispatch('toggleSearch')
    },

    openSearch() {
      this.$store.dispatch('openSearch')
    },
    closeAutocomplete() {
      this.showAutocomplete = false;
    },
    getLengthTerm(term) {
      let lengthTerm = 0;
      for (var i = 0, len = term.length; i < len; i++) {
        if (term[i] !== ' ')
          lengthTerm++;
      }
      return lengthTerm;
    },
    handleSearchAutoComplete(term) {
      clearTimeout(this.debounceSearch);
      this.searchTerm = term;

      if (this.getLengthTerm(this.searchTerm) >= 3) {

        this.debounceSearch = setTimeout(() => {
          this.loadingSearch = true;

          Api.product.searchAutocomplete(term).then((data) => {
            this.showAutocomplete = true;
            this.searchTerms = data;
          }).catch((e) => {
            this.$store.dispatch('sendNotification', {
              type: 'danger',
              message: this.$i18n.t('server error'),
              icon: icons.error
            });
          }).finally(() => {
            this.loadingSearch = false;
          })
        }, 300);
      }


    },

    changeSearchTerm(term) {
      this.searchTerm = term;
      this.showAutocomplete = false;
      this.handleSearch(term)

    },

    handleSearch(term) {
      this.goToSearch()
      /*  if (this.searchTerm.length > 0) {
          this.loadingSearch = true;
          let content = [];
          this.searchResult = {content: content, totalItems: 0, loading: this.loadingSearch}

          this.openSearch()
          Api.product.search(term).then((data) => {

            for (let lightProduct of data.products.content) {
              content.push(LightProduct.of(lightProduct));
            }
            this.searchResult = {content: content, totalItems: data.products.totalElements, loading: false}

          }).catch((e) => {
              // console.error(e)
          }).finally(() => {
                this.loadingSearch = false

              }
          )
        }*/
    },

    goToSearch() {

      this.searchResult = {content: [], totalItems: 0};
      this.$store.dispatch('closeSearch')
      this.$router.push('/recherche?searchTerm=' + this.searchTerm).catch(() => {
        GtagEvent.search(this.searchTerm)
        return null
      })
    }
  }
};
</script>


